import { useEffect } from 'react'
import * as React from 'react'
import useToggle from 'hooks/useToggle'

import { useGlobalExperiencesSearchContext, useGlobalExperiencesSearchResultsTracking } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalExperiencesSearch'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { fetchExperienceCategories } from 'actions/ExperienceActions'
import useQueryParams from 'hooks/useQueryParams'
import { useAppDispatch } from 'hooks/reduxHooks'
import ExperienceSearchHeader from '../../Experiences/ExperiencesSearch/ExperienceSearchHeader'
import { connect } from 'react-redux'
import ExperienceSearchPageFiltersSidebar from 'components/Experiences/ExperiencesSearch/ExperienceSearchPageFiltersSidebar'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import useExperiencesSearchFilters from '../hooks/useExperiencesSearchFilters'

interface MappedStateProps {
  search: string
}

interface Props extends MappedStateProps {
  children: React.ReactNode
  searchMode: Experiences.SearchMode
  list: App.ApiCallState<{
    ids: Array<string>
    placeId: string
  }>
  place?: App.Place
}

function ExperienceSearchPageContainer({ children, searchMode, list, place }: Props) {
  const queryParams = useQueryParams()
  const dispatch = useAppDispatch()
  const { searchFilters } = useExperiencesSearchFilters()

  const [showFilter, toggleShowFilter] = useToggle()

  const { globalExperiencesSearchDispatch, globalExperiencesSearchState } = useGlobalExperiencesSearchContext({
    ...GLOBAL_SEARCH_INITIAL_STATE,
    experienceCategories: searchFilters.categoryCodes ?? [],
    experienceCollections: searchFilters.collections ?? [],
  }, queryParams)

  useEffect(() => {
    dispatch(fetchExperienceCategories())
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useGlobalExperiencesSearchResultsTracking(globalExperiencesSearchState, list.ids, !!list.fetching)

  return <AnalyticsPageContext.Provider value={AnalyticsPage.search}>
    <GlobalSearchContextProvider
      state={globalExperiencesSearchState}
      dispatch={globalExperiencesSearchDispatch}
    >
      <ExperienceSearchPageFiltersSidebar
        open={showFilter}
        place={place}
        onClose={toggleShowFilter}
      />
      <ExperienceSearchHeader
        list={list}
        searchMode={searchMode}
        toggleShowFilter={toggleShowFilter}
      />
      {children}
    </GlobalSearchContextProvider>
  </AnalyticsPageContext.Provider>
}

function mapStateToProps(state: App.State) {
  return {
    search: state.router.location.search,
  }
}

export default connect(mapStateToProps)(ExperienceSearchPageContainer)
